export const ROLE_LIST_READ_REQUESTED = 'ROLE_LIST_READ_REQUESTED';
export const ROLE_LIST_READ_SUCCEEDED = 'ROLE_LIST_READ_SUCCEEDED';
export const ROLE_LIST_READ_FAILED = 'ROLE_LIST_READ_FAILED';
export const ROLE_LIST_RESET = 'ROLE_LIST_RESET';
